"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationIDCard = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsRecognition_1 = require("../../model/hsRecognition");
var service_1 = require("../../../library/base/service");
var VerificationIDCard = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(VerificationIDCard, _super);
    function VerificationIDCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '验证身份证接口';
        _this.code = '105027';
        _this.desc = '验证身份证接口';
        _this.requestParams = new hsRecognition_1.VerificationIDCardRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return VerificationIDCard;
}(service_1.BaseService));
exports.VerificationIDCard = VerificationIDCard;
//# sourceMappingURL=verificationIDCard.js.map